import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileSecurity.css';

interface MenuItemProps {
  icon: React.ReactNode;
  title: string;
  onClick?: () => void;
}

const ProfileSecurity: React.FC = () => {
  const navigate = useNavigate();

  const MenuItem: React.FC<MenuItemProps> = ({ icon, title, onClick }) => (
    <button className="security-menu-item" onClick={onClick}>
      <div className="security-menu-icon-wrapper">
        {icon}
      </div>
      <div className="security-menu-title">{title}</div>
      <svg className="security-menu-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );

  return (
    <div className="security-container">
      {/* Header */}
      <div className="security-header">
        <button className="security-back-button" onClick={() => navigate('/profile')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="security-header-title">Security</h1>
      </div>

      {/* Authentication Methods Section */}
      <div className="security-card">
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15.8333 9.16667H4.16667C3.24619 9.16667 2.5 9.91286 2.5 10.8333V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V10.8333C17.5 9.91286 16.7538 9.16667 15.8333 9.16667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.83331 9.16667V5.83333C5.83331 4.72826 6.27229 3.66846 7.05369 2.88706C7.83509 2.10565 8.89489 1.66667 9.99998 1.66667C11.1051 1.66667 12.1649 2.10565 12.9463 2.88706C13.7277 3.66846 14.1666 4.72826 14.1666 5.83333V9.16667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          title="Passkeys"
        />
        <div className="security-divider" />
        
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z" fill="currentColor"/>
              <path d="M10 12.5C4.47715 12.5 0 14.7386 0 17.5V20H20V17.5C20 14.7386 15.5228 12.5 10 12.5Z" fill="currentColor"/>
            </svg>
          }
          title="Full name"
        />
        <div className="security-divider" />
        
        <MenuItem
          icon={
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M16.625 9.625H4.375C3.33947 9.625 2.5 10.4645 2.5 11.5V17.5C2.5 18.5355 3.33947 19.375 4.375 19.375H16.625C17.6605 19.375 18.5 18.5355 18.5 17.5V11.5C18.5 10.4645 17.6605 9.625 16.625 9.625Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6.125 9.625V6.125C6.125 4.96468 6.58594 3.85188 7.40641 3.03141C8.22688 2.21094 9.33968 1.75 10.5 1.75C11.6603 1.75 12.7731 2.21094 13.5936 3.03141C14.4141 3.85188 14.875 4.96468 14.875 6.125V9.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          title="Password"
        />
        <div className="security-divider" />
        
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15.8333 6.66667C15.8333 5.34058 15.3065 4.06881 14.3688 3.13113C13.4312 2.19345 12.1594 1.66667 10.8333 1.66667C9.50725 1.66667 8.23547 2.19345 7.29779 3.13113C6.36011 4.06881 5.83333 5.34058 5.83333 6.66667C5.83333 12.5 3.33333 14.1667 3.33333 14.1667H18.3333C18.3333 14.1667 15.8333 12.5 15.8333 6.66667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12.275 17.5C12.1285 17.7526 11.9183 17.9622 11.6652 18.108C11.412 18.2537 11.1253 18.3304 10.8333 18.3304C10.5414 18.3304 10.2546 18.2537 10.0015 18.108C9.74832 17.9622 9.53817 17.7526 9.39168 17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          title="Phone number"
        />
      </div>

      {/* Account Management Section */}
      <div className="security-card">
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M18.3333 9.23333V10C18.3323 11.797 17.7504 13.5456 16.6744 14.9849C15.5985 16.4241 14.0861 17.4771 12.3628 17.9866C10.6395 18.4961 8.79769 18.4349 7.11205 17.8122C5.42642 17.1894 3.98718 16.0384 3.00912 14.5309C2.03106 13.0234 1.56648 11.2401 1.68472 9.44693C1.80296 7.65379 2.49766 5.94694 3.66525 4.58089C4.83283 3.21485 6.41064 2.26282 8.16348 1.86679C9.91632 1.47076 11.7502 1.65195 13.39 2.38333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M18.3333 3.33333L10 11.675L7.5 9.175" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          title="Account Connections"
        />
        <div className="security-divider" />
        
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15.8333 8.33333H4.16667C3.24619 8.33333 2.5 9.07953 2.5 10V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V10C17.5 9.07953 16.7538 8.33333 15.8333 8.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.83331 8.33333V5C5.83331 3.89493 6.27229 2.83512 7.05369 2.05372C7.83509 1.27232 8.89489 0.833336 9.99998 0.833336C11.1051 0.833336 12.1649 1.27232 12.9463 2.05372C13.7277 2.83512 14.1666 3.89493 14.1666 5V8.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="10" cy="12.5" r="1.25" fill="currentColor"/>
            </svg>
          }
          title="Devices"
        />
        <div className="security-divider" />
        
        <MenuItem
          icon={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 9.16667C11.3807 9.16667 12.5 8.04738 12.5 6.66667C12.5 5.28596 11.3807 4.16667 10 4.16667C8.61929 4.16667 7.5 5.28596 7.5 6.66667C7.5 8.04738 8.61929 9.16667 10 9.16667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.83334 15.8333V14.1667C5.83334 13.2826 6.1845 12.4348 6.80962 11.8097C7.43475 11.1846 8.28262 10.8333 9.16668 10.8333H10.8333C11.7174 10.8333 12.5652 11.1846 13.1904 11.8097C13.8155 12.4348 14.1667 13.2826 14.1667 14.1667V15.8333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          title="Manage Account"
        />
      </div>
    </div>
  );
};

export default ProfileSecurity;